__turbopack_context__.v({
  "animation": "PdpFavoriteButton-module__CZwpFa__animation",
  "heart": "PdpFavoriteButton-module__CZwpFa__heart",
  "particle": "PdpFavoriteButton-module__CZwpFa__particle",
});
